import * as yup from 'yup';

export const schema = yup.object({
  cardNumber: yup
    .string()
    .min(19, 'La cantidad de caracteres ingresados es inválida')
    .required('La cantidad de caracteres ingresados es inválida'),
  cardCvv: yup
    .string()
    .min(4, 'La cantidad de caracteres ingresados es inválida')
    .required('La cantidad de caracteres ingresados es inválida')
    .matches(/^\d{4}$/, 'Revisa el dato')
});

export { yupResolver } from '@hookform/resolvers/yup';
